import { Field } from 'formik'
import { useEffect } from "react";

import { Label } from "./Label"

import { useDepartamentosOptions, useCities } from "./custom-hooks"

const estadocivil = ["Casado", "Soltero"]
const nacionalidad = ["Albanesa", "Andorrana", "Argentina", "Australiana", "Austriaca", "Belga", "Beliceña", "Bermudesa", "Boliviana", "Brasileña", "Bulgara", "Burundesa", "Canadiense", "Checoslovaca", "Chilena", "China", "Colombiana", "Costarricense", "Cubana", "Danes", "Dominicana", "Ecuotoriana", "Egipcia", "Emirata", "Escosesa", "Eslovaca", "Española", "Estona", "Filipina", "Finlandesa", "Francesa", "Galesa", "Ghanesa", "Granadeña", "Griega", "Guatemalteca", "Guyanesa", "Haitiana", "Holandesa", "Hondureña", "Hungara", "India", "Indonesa", "Inglesa", "Iraki", "Irani", "Irlandesa", "Islandesa", "Israeli", "Italiana", "Jamaiquina", "Japonesa", "Jordana", "Katensa", "Keniana", "Kuwaiti", "Laosiana", "Leonesa", "Lesothensa", "Letonesa", "Libanesa", "Liberiana", "Libeña", "Liechtenstein", "Lituana", "Luxemburgo", "Madagascar", "Malaca", "Malawi", "Maldivas", "Mali", "Maltesa", "Marfilesa", "Marroqui", "Mauricio", "Mauritana", "Mexicana", "Monaco", "Mongolesa", "Nauru", "Neozelandesa", "Nicaraguense", "Nigerana", "Nigeriana", "Norcoreana", "Norirlandesa", "Norteamericana", "Noruega", "Panameña", "Paraguaya", "Peruana", "Polaca", "Portoriqueña", "Portuguesa", "Rumana", "Rusa", "Salvadoreña", "Sovietica", "Suazilandesa", "Sudafricana", "Sudanesa", "Sueca", "Suiza", "Surcoreana", "Tailandesa", "Tanzana", "Tonga", "Tongo", "Trinidad y Tobago", "Tunecina", "Turca", "Uruguaya", "Vaticano", "Venezolana"]

const CompletarDatosCampos = ({ setFieldValue, values, url, headers, handleChange, reporte = '', dataAlumno={}, setErrors,validateForm }) => {

    const options = useDepartamentosOptions(url, headers)
    const [municipios, handleMunicipio] = useCities(url, headers, 'E_Depto')

    useEffect(() => {
        
        
       if (reporte === 'reporte'){
           setFieldValue('Cel'     ,       dataAlumno.Cel)
           setFieldValue('E_Telcasa'     , dataAlumno.E_Telcasa)
           setFieldValue('EmailE'     ,    dataAlumno.Email)
           setFieldValue('E_EmailE'     ,  dataAlumno.Email)
           setFieldValue('IdSolicitud'   , dataAlumno.id)
           setFieldValue('IdSede'     ,    dataAlumno.IdSede)
           setFieldValue('IdGrado'     ,   dataAlumno.IdGrado)
           setFieldValue('FechaNac'     ,  dataAlumno.FechaNac)
           setFieldValue('E_DPI'     ,     dataAlumno.E_DPI)
           setFieldValue('E_Edad'     ,    dataAlumno.E_Edad)
           setFieldValue('E_Sexo'     ,    dataAlumno.E_Sexo)
           setFieldValue('E_EstadoCiv'    ,dataAlumno.E_EstadoCiv)
           setFieldValue('E_Ocupa'     ,   dataAlumno.E_Ocupa)
           setFieldValue('Nacionalidad'  , dataAlumno.Nacionalidad)
           setFieldValue('E_Direcc'     ,  dataAlumno.E_Direcc)
           setFieldValue('Email'     ,     dataAlumno.Email)
           setFieldValue('E_Depto'     ,   dataAlumno.E_Depto)
           setFieldValue('Apellidos' ,     dataAlumno.Apellidos)
           setFieldValue('ApellidosE' ,    dataAlumno.E_Apellidos)
           setFieldValue('ColAnterior' ,   dataAlumno.ColAnterior)
           setFieldValue('Dpi' ,           dataAlumno.E_DPI)
           setFieldValue('E_Apellidos' ,   dataAlumno.E_Apellidos)
           setFieldValue('E_Nombres' ,     dataAlumno.E_Nombres)
           setFieldValue('FechaNac' ,      dataAlumno.FechaNac)
           setFieldValue('FechaNace' ,     dataAlumno.FNacimiento)
           setFieldValue('Genero' ,        dataAlumno.Sexo)
           setFieldValue('IdPlan' ,        dataAlumno.IdPlan)
           setFieldValue('Nombres' ,       dataAlumno.Nombres)
           setFieldValue('NombresE' ,      dataAlumno.E_Nombres)
           setFieldValue('id' ,            dataAlumno.id)
           setFieldValue('Diplomado' ,"")
           setFieldValue('FechaNaceE' ,"")
           setErrors({})
           validateForm()
           
           if (dataAlumno.E_Depto !== '') {
               handleMunicipio(dataAlumno.E_Depto, setFieldValue);
               setFieldValue('E_Muni', dataAlumno.E_Muni);
           }
       }else{

           
           if (values.E_Depto !== '') {
               handleMunicipio(values.E_Depto, setFieldValue);
              // setFieldValue('E_EstadoCiv', dataAlumno.E_EstadoCiv);
               setFieldValue('E_Muni', values.E_Muni);
           }
       }
        
    }, [values.IdSolicitud, dataAlumno.id])
    
    
                
    
                
                //setFieldValue('Email',values.Email);
                //setFieldValue('E_Depto',values.E_Depto);
                //setFieldValue('E_Depto',values.E_Depto);
                //setFieldValue('E_Muni',values.E_Muni);
                //setFieldValue('E_Muni',values.E_Muni);
 
    const handleSex = (e, setFieldValue) => {
        setFieldValue('E_Sexo', e.target.value)
    }


    return (
        <div className="px-4 py-4 lg:grid grid-cols-5 gap-4 rounded-lg bg-primarioMira">
            <div className="col-span-full lg:col-start-1 lg:col-end-1 row-start-1">
                <Label lbl="DPI" field="E_DPI" />
                <Field
                    type='number'
                    name='E_DPI'
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                </Field>
            </div>
            <div className="col-span-full lg:col-start-2 lg:col-end-2 row-start-1">
                <Label lbl="Celular" field="Cel" />
                <Field
                    disabled={true}
                    type='number'
                    name='Cel'
                    className="mt-1 block w-full rounded-md border-gray-300 bg-grisMira shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                </Field>
            </div>
            <div className="col-span-full lg:col-start-3 lg:col-end-3 row-start-1">
                <Label lbl="Edad" field="E_Edad" />
                <Field
                    type='number'
                    min='18'
                    name='E_Edad'
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                </Field>
            </div>
            <div className="col-span-full lg:col-start-4 lg:col-end-4 row-start-1">
                <Label lbl="Teléfono de casa" field="E_Telcasa" />
                <Field
                    type='number'
                    name='E_Telcasa'
                    minlength="8"
                    maxLength="8"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                </Field>
            </div>
            <div className="col-span-full lg:col-start-5 lg:col-end-5 row-start-1">
                <Label lbl="Estado civil" field="E_EstadoCiv" />
                <Field
                    name="E_EstadoCiv"
                    as='select'
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                    <option value=''>---Selecciona estado civil---</option>
                    {
                        estadocivil.map((estadoc, key) => <option key={key} value={estadoc}>{estadoc}</option>)
                    }
                </Field>
            </div>
            <div className="py-2 px-2 mt-4 mb-4 col-span-full lg:col-start-1 lg:col-end-1 row-start-2 bg-secundarioMira rounded-lg border border-grisMira shadow-2xl">
                <label lbl="E_Sexo" field="E_Sexo"
                className="flex text-sm font-medium leading-7 text-white"
                >Género</label>
                <div>
                    <span className="text-sm text-white">Masculino</span>
                    <Field
                        type="radio"
                        name="E_Sexo"
                        className="ml-1 mr-2 text-salmon cursor-pointer"
                        value='M'
                        checked={values.E_Sexo === 'M'}
                        //onChange={(e) => handleSex(e, setFieldValue)}
                    />
                    <span className="text-sm text-white">Femenino</span>
                    <Field
                        type="radio"
                        className="ml-1 text-salmon cursor-pointer"
                        value='F'
                        name="E_Sexo"
                        //onChange={(e) => handleSex(e, setFieldValue)}
                        checked={values.E_Sexo === 'F'}
                    />
                </div>
            </div>
            <div className="col-span-full lg:col-start-2 lg:col-end-4 row-start-2">
                <Label lbl="Correo electrónico" field="EmailE" />
                <Field
                    disabled={true}
                    type='email'
                    name='EmailE'
                    className="mt-1 block w-full rounded-md border-gray-300 text-sm bg-grisMira shadow-sm focus:border-secundario focus:ring-secundario">
                </Field>
            </div>
            <div className="col-span-full lg:col-start-4 lg:col-end-6 row-start-2">
                <Label lbl="Ocupación" field="E_Ocupa" />
                <Field
                    type='text'
                    name='E_Ocupa'
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                </Field>
            </div>
            <div className="col-span-full lg:col-start-1 lg:col-end-2 row-start-3">
                <Label lbl="Nacionalidad" field="Nacionalidad" />
                <Field
                    name="Nacionalidad"
                    as='select'
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                    <option value="">---Selecciona nacionalidad---</option>
                    {
                        nacionalidad.map((nacion, key) => <option key={key} value={nacion}>{nacion}</option>)
                    }
                </Field>
            </div>
            <div className="col-span-full lg:col-start-2 lg:col-end-4 row-start-3">
                <Label lbl="Departamento" field="E_Depto" />
                <Field
                    onChange={(e) => {
                    handleMunicipio(e.target.value, setFieldValue)}}
                    name="E_Depto"
                    as='select'
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                    <option value="">---Selecciona departamento---</option>
                    {options?.departamentos_ins?.map(dept =>
                        <option key={dept.Codigo} value={dept.Codigo}>{dept.Departamento}</option>
                    )}
                </Field>
            </div>
            <div className="col-span-full lg:col-start-4 lg:col-end-6 row-start-3">
                <Label lbl="Municipio" field="E_Muni" />
                <Field
                    name="E_Muni"
                    value={values.E_Muni}
                    as='select'
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                    <option value="">---Selecciona municipio---</option>
                    {municipios.map(mun =>
                        <option key={mun.Codigo} value={mun.Codigo}>{mun.Municipio}</option>
                    )}
                </Field>
            </div>
            <div className="col-span-full lg:col-start-1 lg:col-end-6 row-start-4">
                <Label lbl="Dirección" field="E_Direcc" />
                <Field
                    type='search'
                    name='E_Direcc'
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                </Field>
            </div>
        </div>
    )
}

export default CompletarDatosCampos